"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Loader = void 0;

var _react = _interopRequireDefault(require("react"));

var _Loader = require("./Loader.style");

var _core = require("@emotion/core");

const Loader = () => {
  return (0, _core.jsx)(_Loader.LoaderSpinner, {
    "data-testid": "loader-spinner"
  });
};

exports.Loader = Loader;
Loader.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Loader"
};